import axios from '@/axios'

const email = {
    //订阅列表
    async emailList(params = {}) {
        return await axios.post('uc/user/userinfo/topiclist', params, { des: '订阅列表', sTime: new Date().getTime() })
    },
    async managemail(params = {}) {
        return await axios.post('uc/user/userinfo/emailsub', params, { des: '订阅||取消订阅', sTime: new Date().getTime() })
    }
}

export default email


// WEBPACK FOOTER //
// ./src/api/email.js